import { useState } from "react";

import { ActionsMenu, ActionsMenuButton, MenuItem } from "ui/actions-menu";
import ControlBar from "components/partials/control-bar/control-bar";

import Icons from "assets";

import type { CampaignTemplate } from "containers/admin/clients/client/campaign-templates-page/campaign-templates-page.types";

type CampaignTemplatesContextMenuProps = {
  allSelectedAmount: number;
  totalTemplates: number;
  selectedTemplates: CampaignTemplate[];
  onArchiveTemplates: (templates: CampaignTemplate[]) => void;
};

const CampaignTemplatesContextMenu = ({
  allSelectedAmount,
  totalTemplates,
  selectedTemplates,
  onArchiveTemplates,
}: CampaignTemplatesContextMenuProps) => {
  const [isActionsDropdownOpen, setIsActionsDropdownOpen] = useState(false);

  const handleActionsDropdownOpen = () => setIsActionsDropdownOpen(true);
  const handleActionsDropdownClose = () => setIsActionsDropdownOpen(false);

  if (!allSelectedAmount) {
    return null;
  }

  const handleArchiveTemplates = () => {
    onArchiveTemplates(selectedTemplates);
    setIsActionsDropdownOpen(false);
  };

  return (
    <ControlBar variant="inset">
      <span className="text-gray-900 text-sm font-medium px-1.5">
        Selected {allSelectedAmount} of {totalTemplates} items
      </span>

      <ActionsMenu
        itemName="selected campaign briefs"
        open={isActionsDropdownOpen}
        offsetLeft={2}
        offsetTop={10}
        onOpen={handleActionsDropdownOpen}
        onClose={handleActionsDropdownClose}
        trigger={
          <ActionsMenuButton variant="outlined" size="large">
            Actions
          </ActionsMenuButton>
        }>
        <MenuItem
          icon={<Icons.Archive />}
          label="Archive brief"
          color="error"
          onClick={handleArchiveTemplates}
        />
      </ActionsMenu>
    </ControlBar>
  );
};

export default CampaignTemplatesContextMenu;
